import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[konTemplateKey]',
  standalone: true,
})
export class TemplateKeyDirective {
  @Input('konTemplateKey') key!: string;

  constructor(public template: TemplateRef<any>) {}
}
